window.scan = (e) => {
    const code = document.getElementById('scan_area').value
    if(code.length===5)
    {
        const toHalf = code.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        })
        document.getElementById('scan_area').value = ''
        const id = Number(toHalf)
        if(id&&e.code!=='Enter')
        {
            execRead(id)
        }
    }
}

window.reloadTracking = (locate) => {
    console.log(locate)
    setTimeout(()=>location.reload(),1000)
}

const execRead = async (id) => {
    const response = await axios.get('/operation/setting/check/'+id)
    if(response.data.result === 'OK')
    {
        document.getElementById('barcode_blur').value="0"
        mediaDownloads(id,(request1)=>{
            $.get("/operation/index/downloaded/"+id,()=>{
                if(request1.rows!==null)
                {
                    mediaOpenFilesBarcode(id,(request2)=>{
                        //location.href= '/operation/setting/barcode'
						switchToSetting();
                    })
                }
                else
                {
                    alert('取得するファイルがありませんでした')
                    //location.href= '/operation/setting/barcode'
					switchToSetting();
                }
            })
        })
    }
    else
    {
        alert('無効なコードです')
    }
}
/*
const scan = (e) => {
    if(e.keyCode===13||e.code==="Enter")
    {
        const code = document.getElementById('scan_area').value
        const toHalf = code.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        })
        document.getElementById('scan_area').value = ''
        const id = Number(toHalf)
        if(id)
        {
            mediaDownloads(id,()=>{
                mediaOpenDirectory(id)
            })
        }
    }
}
*/            
window.clearCode = () => {
    document.getElementById('scan_area').value = ''
}

window.switchTobarcode = () => {
	$('#content_setting').css('display','none');
	$('#content_barcode').css('display','flex');
	$('body').removeClass('page-setting');
	$('body').addClass('page-setting-qr');
	clearCode();
	scanFocus();
}

window.switchToSetting = () => {
    $('#content_setting').css('display','flex');
	$('#content_barcode').css('display','none');
	$('body').removeClass('page-setting-qr');
	$('body').addClass('page-setting');
}

window.scanFocus = () => {
	if ($('#scan_area').length) {
		$('#scan_area').focus();
	}
}

window.pageBack = () => {
    if(document.getElementById('barcode_blur').value==="1")
    {
        location.href= '/operation/setting/barcode'
    }
}

window.settingsInital = () => {
    if(localStorage.getItem('auto_dl')==='1') {
		let onBtn = document.getElementById('auto-dl-on');
		if (onBtn) {
			onBtn.checked = true;
		}
	} else {
		let offBtn = document.getElementById('auto-dl-off');
		if (offBtn) {
			offBtn.checked = true;
		}
	}
}


window.changeCurrentTable = async () => {
    const params = new URLSearchParams()
    params.append('day',document.querySelector('[name=day]').value)
    if(document.querySelector('[name=room]')) {
        params.append('room',document.querySelector('[name=room]').value)
    }
    const response = await axios.post('/operation/index/change',params)
    reloadTracking('changeCurrentTable')
    //document.getElementById('select_day_form').submit()
}

window.changeCongestion = async (id,congestion) => {
	const response = await axios.post('/operation/congestion/'+id+'/'+congestion)
	if(response.data.result==='OK')
	{
        reloadTracking('changeCongestion')
	}
}

window.operationMainLoop = async (intervalSpan) => {
	// 条件が有効な時に処理をする
	if (document.getElementById('message_accept').value==='1')
	{
		try {
			const response = await axios.post("/operation/message/active_message")
			const data = response.data

			if (login_user_id != data['login_user_id']) {
				if (!alert('別のアカウントでログインされています。画面を更新します。')) {
					location.href = '/login/' + data['login_society'];
				}
			} else {
				$('#active-message').text(data['msg']);
				$('#active-room-staff-name').text(data['room_staff_name']);
				$('#active-datetime').text(data['upd_datetime']);
				$('#active_message_link').attr('href', '/operation/message/'+data['message_route'])
				if(Number($('#notify_count').text())<data['notify_count']) {
					if(document.getElementById('is_admin').value=='1') {
						playSE('new_message')
					}
				}
				const notify = (data['notify_count']>0)?('<span class="badge">'+data['notify_count']+'</span>'):''
				$('#notify_count').html(notify)
				/* 不使用
				const activeMessageId = $('#active_message_id').val()
				// メッセージ画面且つ新着メッセージIDに変更があった場合
				if($('#tab_name').val()==='message'
					&& activeMessageId !== ''
					&& activeMessageId !== ''+data['t_msg_id'])
				{
					if (document.getElementById('message_page').value==='list') {
						//location.reload()
					}
				}
				*/
				$('#active_message_id').val(data['t_msg_id'])
				// 外部で変更があった場合
				if($('#current_congestion').val()!==data['congestion'])
				{
					$('#current_congestion').val(data['congestion'])
					$('#congestion_1').removeClass('active')
					$('#congestion_2').removeClass('active')
					$('#congestion_3').removeClass('active')
					$('#congestion_4').removeClass('active')
					$('#congestion_'+data['congestion']).addClass('active')
				}	
			}
		} catch(e) {
			//const url ='/login/'+document.getElementById('society_id').value
			//setTimeout(()=>{location.href=url},1000)
		}
		
	}

	// 特定の条件を満たしたらループ停止
	//if(any) {
		setTimeout(()=>operationMainLoop(intervalSpan),intervalSpan)
	//}
}

/**
 * 次のプログラムを自動ダウンロード
 */
window.nextPgmAutoDL = (t_pgm_subject_id) => {
    if(localStorage.getItem('auto_dl')==='1') {
        download_status = true;
        // デバッグ用
        // setTimeout()(function(){
        //   dlStatusUpdateDownload(
        //     t_pgm_subject_id,
        //     1,
        //     ()=>{ download_status = false; }
        //   ),
        //   3000
        //  });
        // ダウンロードスキーマ
        mediaDownloads(t_pgm_subject_id,
            ()=>{
                dlStatusUpdateDownload(
                   t_pgm_subject_id,
                   1,
                    ()=>{ download_status = false; }
                )
            }
        )
    }
}

/**
 * リモートDL
 */
window.remoteDownloads = (t_pgm_subject_id) => {
    download_status = true;
    if (t_pgm_subject_id === "undefined") {
        clearInterval(remoteDownloadsTimerId)
        return
    }
    // デバッグ用
    // setTimeout(function(){
    //   dlStatusUpdateDownload(
    //     t_pgm_subject_id,
    //     1,
    //     ()=>{ 
    //       remote_dl_status_key++;
    //       download_status = false;
    //     }
    //   ),
    //   3000
    // }); 
    // ダウンロードスキーマ
    mediaDownloads(
    t_pgm_subject_id,
    ()=>{ 
        dlStatusUpdateDownload(
            t_pgm_subject_id,
            1,
            ()=>{ 
                remote_dl_status_key++;
                download_status = false;
            }
        )
    })
}

const taskInterval=5

window.getNewGroupMessage = async () => {
	console.log('getNewGroupMessage')
	try {
		const params = new URLSearchParams()
		params.append('group_id',document.getElementById('group_id').value)
		params.append('readed_id',document.getElementById('latest_id').value)
		const response = await axios.post("/operation/message/get_group_message",params)
		const data = response.data
		document.getElementById('latest_id').value = data.latest.latest_id
		addMessage(data.messages,'m_staff_id','staff_name')
	} catch(e) {
	}
	setTimeout(getNewGroupMessage,taskInterval*1000)
}

window.getNewDirectMessage = async () => {
	console.log('getNewDirectMessage')
	try {
		const params = new URLSearchParams()
		params.append('partner_id',document.getElementById('partner_id').value)
		params.append('readed_id',document.getElementById('latest_id').value)
		const response = await axios.post("/operation/message/get_direct_message",params)
		const data = response.data
		document.getElementById('latest_id').value = data.latest.latest_id
		addMessage(data.messages,'sender_id','sender_name')
	} catch(e) {
	}
	setTimeout(getNewDirectMessage,taskInterval*1000)
}

window.getNewMessageList = async () => {
	try {
		const response = await axios.post("/operation/message/get_message_list")
		const data = response.data
		const latestTime = document.getElementById('latest_time').value
		if (data.rows.length>0) {
			// 新着があったら
			if(latestTime !== data.rows[0].upd_datetime) {
				const messageListArea = document.getElementById('message_list_area')
				document.getElementById('latest_time').value = data.rows[0].upd_datetime
				while (messageListArea.lastChild) {
					messageListArea.removeChild(messageListArea.lastChild)
				}
				for (let row of data.rows) {
					const child = document.createElement('a')
					child.classList.add('item')
					child.setAttribute('href',`/operation/message/${row.type}/${row.id}`)
					child.innerHTML = `
						<div class="area-icon">
							<div class="icon icon-account">${row.name.charAt(0)}</div>
						</div>
						<div class="area-name">
							<div class="text text-name">${row.name}</div>
						</div>
						<div id="${row.type}_${row.id}_count_area" class="area-badge" style="display:${row.unread_count>0?'block':'none'}">
							<div id="${row.type}_${row.id}_count_badge" class="icon icon-badge">${row.unread_count}</div>
							<input type="hidden" id="${row.type}_${row.id}_count" value="${row.unread_count}" />
						</div>
						<div class="area-message">
							<div class="text text-message">
								${row.msg}
							</div>
						</div>
						<div class="area-date">
							<div class="text text-date">${row.upd_datetime?row.upd_datetime.substring(0,16).replace('-','/'):''}</div>
						</div>
					`
					messageListArea.appendChild(child)
				}
			// 新着がなくても通知件数だけチェック差異があれば更新
			} else {
				for (let row of data.rows) {
					const count_monitor = document.getElementById(row.type+"_"+row.id+"_count")
					console.log(count_monitor)
					if(Number(document.getElementById(row.type+"_"+row.id+"_count").value)!==row.unread_count) {
						document.getElementById(row.type+"_"+row.id+"_count").value = row.unread_count
						document.getElementById(row.type+"_"+row.id+"_count_area").style.display = row.unread_count>0?'block':'none'
						document.getElementById(row.type+"_"+row.id+"_count_badge").innerText = row.unread_count
					}
				}
			}
		}
	} catch(e) {
	}
	setTimeout(getNewMessageList,taskInterval*1000)
}

const addMessage = (messages,id,name) => {
	const staffId = document.getElementById('staff_id').value
	const messageArea = document.getElementById('message_area')
	let newMessageCount=0
	for(let message of messages) {
		const child = document.createElement('div')
		child.classList.add('message')
		if(message[id] === staffId) {
			child.classList.add('message-me')
		} else {
			child.classList.add('message-they')
			newMessageCount++
		}
		child.innerHTML = `
		<div class="area-content">
		<div class="text text-message">
		${message.msg}
		</div>
		</div>
		<div class="area-info">
		<div class="icon icon-account">${message[name].charAt(0)}</div>
		<div class="text text-name">${message[name]}</div>
		<div class="text text-date">${message.upd_datetime}</div>
		</div>
		`
		messageArea.appendChild(child) 
	}
	if(newMessageCount>0)
	{
		if(document.getElementById('is_admin').value=='1') {
			playSE('new_message')
		}
	}
}

window.onSubmitMessage = (e) => {
	e.preventDefault()
	let message = document.querySelector('#send_message [name=message]').value
	message = message.replaceAll(' ','').replaceAll('\n','').replaceAll('\r','')
	if (message !== '') {
		document.querySelector('#send_message').submit()
	}
}

window.changeCoi = async (id) => {
	const dom = document.getElementById('coi_'+id)
	const response = await axios.post("/operation/index/coi/"+id+"/"+(dom.checked?1:0))
}

window.operationOpenFiles = (id) => {
	mediaOpenFiles(id,(response)=>{
		if(response.rows===null||response.rows==='')
		{
			alert('対象のファイルが見つかりません。\nダイアログを閉じてから再度ダウンロードしてください。')
		}
	})
}

window.operationOpenDirectory = (id) => {
	mediaOpenDirectory(id)
}


window.initParams = async () => {
    const params = new URLSearchParams()
    params.append('latest_subject_time',document.getElementById('latest_subject_time').value)
    params.append('latest_self_dl_time',document.getElementById('latest_self_dl_time').value)
    params.append('latest_pair_dl_time',document.getElementById('latest_pair_dl_time').value)
    const response = await axios.post('/operation/index/changes',params)
    if (response.data.selfStaffId!==document.getElementById('self_id').value) {
        console.log('rewrite:self_id')
        document.getElementById('self_id').value = response.data.selfStaffId
    }
    if (response.data.pairStaffId!==document.getElementById('pair_id').value) {
        console.log('rewrite:pair_id')
        document.getElementById('pair_id').value = response.data.pairStaffId
    }
    if (response.data.leftStaffId!==document.getElementById('left_id').value) {
        console.log('rewrite:left_id')
        document.getElementById('left_id').value = response.data.leftStaffId
    }
    if (response.data.rightStaffId!==document.getElementById('right_id').value) {
        console.log('rewrite:right_id')
        document.getElementById('right_id').value = response.data.rightStaffId
    }
    if (response.data.leftStaffLoginId!==document.getElementById('left_login').value) {
        if(document.getElementById('is_admin').value!=='1'||document.getElementById('left_login').value!=="") {
            console.log('rewrite:left_login')
            document.getElementById('left_login').value = response.data.leftStaffLoginId
        }
    }
    if (response.data.rightStaffLoginId!==document.getElementById('right_login').value) {
        if(document.getElementById('is_admin').value!=='1'||document.getElementById('right_login').value!=="") {
            console.log('rewrite:right_login')
            document.getElementById('right_login').value = response.data.rightStaffLoginId
        }
    }
    console.log('finish init')
}
